import { IconButton } from '@mui/material';

import { styled } from '../../../../../theme';

export const StyledIconButton = styled(IconButton)`
  margin-right: -12px;
`;
